import * as React from 'react';
import { Layout } from '../common/Layout';
import { ResetPasswordFlowForms } from '../../../core/enums';
import ForgotPasswordSuccessForm from './forms/ResetPasswordSuccessForm';
import ForgotPasswordForm from './forms/ResetPasswordForm';
import { loginPageUrl } from '../../../core/constants';
import Helmet from '../../../commonComponents/Helmet';
import { useNavigateWithAppName } from '../../common/NavigateWithAppName';

const ResetPasswordPage = () => {
	const navigate = useNavigateWithAppName();
	const [activeForm, setActiveForm] = React.useState(ResetPasswordFlowForms.ResetPasswordForm);
	const [showResetPasswordForm, setShowResetPasswordForm] = React.useState(true);
	const [showResetPasswordSuccessForm, setShowResetPasswordSuccessForm] = React.useState(false);

	const showForm = (nextForm: ResetPasswordFlowForms) => {
		setActiveForm(nextForm);
		setShowResetPasswordForm(nextForm === ResetPasswordFlowForms.ResetPasswordForm);
		setShowResetPasswordSuccessForm(nextForm === ResetPasswordFlowForms.ResetPasswordSuccessForm);
	};

	const handleSumit = () => {
		showForm(ResetPasswordFlowForms.ResetPasswordSuccessForm);
	};

	const handleBackButtonClick = () => {
		switch (activeForm) {
			case ResetPasswordFlowForms.ResetPasswordSuccessForm:
				setShowResetPasswordSuccessForm(false);
				showForm(ResetPasswordFlowForms.ResetPasswordForm);
				break;
			default:
				navigate(loginPageUrl);
		}
	};

	return (
		<Layout headerText="Reset password" onBackButtonClick={handleBackButtonClick}>
			<Helmet>
				<title>Reset password</title>
			</Helmet>
			{showResetPasswordForm && <ForgotPasswordForm onSubmit={handleSumit} />}
			{showResetPasswordSuccessForm && <ForgotPasswordSuccessForm />}
		</Layout>
	);
};

export default ResetPasswordPage;
